import React, {useCallback, useEffect, useMemo, useRef, useState} from "react";
import {Link, useHistory, useParams} from "react-router-dom";
import InterSectionObserver from '../../../common/components/intersection/InterSectionObserver';
import useFetch from "@common/hooks/fetch/useFetch";
import {Moments} from "@common/utils/date/moments";
import {
  getAdGlobalDetail,
  getAdGlobalList,
  getAdGlobalTextDetail,
  getAdGlobalVideoDetail,
} from "@common/services/restapi/forum";
import ViewIcon from "../../assets/image/icon_eye.svg";
import Split from "../../assets/image/split.svg";
import Prev from "../../assets/image/icon_prev.svg";
import {LazyLoadImage} from 'react-lazy-load-image-component';
import Global from "@common/enums/Global.enums";
import Page from "@common/enums/Page.enums";
import NewTab from "../component/NewTab";
import {convertPath} from "@common/utils/path/linkPath";

const AD_GLOBAL_MENU = [Global.text, Global.video];

function GlobalCreative() {
  const history = useHistory();
  const {forumType} = useParams();

  const [forumList, setForumList] = useState([]);
  const [page, setPage] = useState(Page.page.defaultPage);

  const searchQuery = useMemo(() => {
    return {
      category: forumType,
      pageNumber: page,
      pageSize: Page.size.defaultSize
    }
  },[page]);

  const {data, loading: dataLoading} = useFetch(() => getAdGlobalList(searchQuery), [searchQuery], {});

  const handleGoBack = useCallback(() => {
    history.goBack();
  }, []);

  const handleTabMove = useCallback((forumType) => {
    window.location.href = convertPath('/forum/' + forumType);
  }, []);

  useEffect(() => {
    if (data && data.articleList) {
      setForumList(forumList.concat(data.articleList));
    }
  }, [data]);

  const handleObserver = useCallback(() => {
    setPage(page + 1);
  }, [page]);

  return (
    <>
      <div className="common-header--top">
        <a className="prev-btn" onClick={handleGoBack}>
          <img src={Prev} alt=""/>
        </a>
        <h3 className="header-title">글로벌 크리에이티브</h3>
      </div>

      <section className="common-body--list">
        <NewTab
          additionalClassName="mb-4"
          selectedThing={Global.enumValueOf(forumType).enumKey}
          setSelectedThing={handleTabMove}
          thingsList={AD_GLOBAL_MENU}
        />
        <div className="global-list-small">
          <div className="ad-list">
            {
              forumList.length > 0 &&
              forumList.map((global, index) => {
                return (
                  <a href={convertPath(`/forum/${forumType}/${global.ukey}`)} key={index}>
                    <div className="ad-box small-horizontal" key={`${global.ukey}`}>
                      <div className="thumbnail-card global-thumbnail">
                        <LazyLoadImage src={`${global.thumbnail.replace('/l/', '/m/').replace("http:", "https:")}`}/>
                      </div>
                      <div className="ad-info">
                        <div className="left-box">
                          <h4 className="title">{global.title} </h4>
                          <h5 className="company">{global.source}</h5>
                          <div className="row-box">
                            <div className="view-count">
                              <img src={ViewIcon} alt=""/>
                              <span>{global.rcount && global.rcount}</span>
                            </div>
                            <img src={Split} alt=""/>
                            <div className="created-date">{Moments.Format(global.wdate, 'yyyy.MM.DD')}</div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </a>
                )
              })
            }
          </div>
          <InterSectionObserver dataLoading={dataLoading} onHandleObserver={handleObserver}/>
        </div>
      </section>
    </>
  )
}

export default GlobalCreative
